import { createStore, createEvent, createEffect, sample } from "effector";
import { NotificationsState, NotificationsApiResponse } from "./types";
import { notificationsService } from "./service";

// Events
export const fetchNotificationsRequested = createEvent();
export const markNotificationAsReadRequested = createEvent<string>();

// Effects
export const fetchNotificationsFx = createEffect(
  async (): Promise<NotificationsApiResponse> => {
    return await notificationsService.getAllNotifications();
  }
);

export const markNotificationAsReadFx = createEffect(
  async (notificationId: string): Promise<string> => {
    await notificationsService.markAsRead(notificationId);
    return notificationId;
  }
);

// Store
export const $notificationsStore = createStore<NotificationsState>({
  notifications: [],
  loading: false,
  error: null,
  unreadCount: 0,
});

// Store handlers
$notificationsStore
  .on(fetchNotificationsRequested, (state) => ({
    ...state,
    loading: true,
    error: null,
  }))
  .on(fetchNotificationsFx.doneData, (state, response) => ({
    ...state,
    notifications: response.data,
    loading: false,
    error: null,
    unreadCount: response.data.filter((n) => n.is_read === "0" || n.is_read === false).length,
  }))
  .on(fetchNotificationsFx.failData, (state, error) => ({
    ...state,
    loading: false,
    error: error.message || "Failed to fetch notifications",
  }))
  .on(markNotificationAsReadFx.doneData, (state, notificationId) => ({
    ...state,
    notifications: state.notifications.map((notification) =>
      notification.id === notificationId
        ? { ...notification, is_read: true }
        : notification
    ),
    unreadCount: Math.max(0, state.unreadCount - 1),
  }));

// Samples
sample({
  clock: fetchNotificationsRequested,
  target: fetchNotificationsFx,
});

sample({
  clock: markNotificationAsReadRequested,
  target: markNotificationAsReadFx,
});

// Derived stores
export const $unreadNotificationsCount = $notificationsStore.map(
  (state) => state.unreadCount
);
